<template>
    <el-dialog :visible="visible" :modal-append-to-body="false" class="ah-detail-dialog declare-hint-dialog" append-to-body :before-close="() => onClose(false)">
        <template slot="title"> 警告 </template>
        <div class="container">
            <div class="img-block">
                <img src="alertMark.jpg" alt="" />
            </div>
            <div class="text">
                <div>您確定要改為未申報／不申報扣抵？</div>
                <div>請注意避免重複申報。</div>
            </div>
            <div>
                <el-button @click="onClose(false)">否</el-button>
                <el-button type="primary" @click="onClose(true)">是</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: Boolean,
        count: Number,
    },
    computed: {
    },
    methods: {
        onClose(val) {
            this.$emit('confirmed', val);
        },
    },
};
</script>

<style lang="scss">
.declare-hint-dialog {
    display: flex;
    .container {
        padding: 20px;
        text-align: center;
    }
    .img-block {
        border: 1px solid #000;
        width: 70px;
        height: 70px;
        margin: auto;
    }
    .text {
        font-size: 16px;
        font-weight: bold;
        margin: 35px 0;
    }
    .el-dialog {
        width: 100%;
        max-width: 350px;
        margin: auto !important;
    }
}
</style>
